import {
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import boxStyles from "../../../../styles/boxStyles";
import DeleteIcon from "@mui/icons-material/Delete";
import fieldStyles from "../../../../styles/fieldStyles";

const kategoriCLSTItem = [
  { id: "1", value: "1. Safe Zone Position", name: "1. Safe Zone Position" },
  { id: "2", value: "2. Permit to Work", name: "2. Permit to Work" },
  { id: "3", value: "3. Tools & Equipment", name: "3. Tools & Equipment" },
  { id: "4", value: "...", name: "..." },
];

const AnalisaPenyebab = ({ inputFields, setInputFields, media, setMedia }) => {
  const [document, setDocument] = useState(null);

  const handleInputFile = (e) => {
    const files = e.target.files[0];

    let err = "";

    var formData = new FormData();

    if (!files) return console.log("File does not exist.");

    if (files.size > 1024 * 1024 * 10) {
      return console.log("Ukuran file maximum 10 Mb.");
    }

    if (err !== "") {
      alert(err);
    }

    formData.append("file", files);

    setMedia(formData);

    setDocument(files);
  };

  const handleRemoveFile = () => {
    setMedia(null);
    setDocument(null);
  };

  return (
    <div>
      <Box component="div" sx={boxStyles}>
        <center>
          <h3>ANALISA PENYEBAB</h3>
        </center>
        <Stack spacing={2}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Kategori CLSR (Corporate Life Saving Rules)
            </InputLabel>
            <Select
              // value={unit}
              // onChange={handleUnit}
              label="Kategori CLSR"
              required
            >
              {kategoriCLSTItem.map((data) => (
                <MenuItem id={data.id} key={data.id} value={data.id}>
                  {data.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <left>
            <h4>Penyebab Langsung</h4>
          </left>
          <TextField
            name="PenyebabLangsung"
            // label="Penyebab Langsung"
            variant="outlined"
            fullWidth
            // value={input}
            onChange={(e) =>
              setInputFields({
                ...inputFields,
                penyebabLangsung: e.target.value,
              })
            }
          />
          <left>
            <h4>Penyebab Dasar</h4>
          </left>
          <TextField
            name="penyebabDasar"
            //label="Penyebab Dasar"
            variant="outlined"
            fullWidth
            // value={input}
            onChange={(e) =>
              setInputFields({
                ...inputFields,
                penyebabDasar: e.target.value,
              })
            }
          />
          <left>
            <h4>Rekomendasi</h4>
          </left>
          <TextField
            name="rekomendasi"
            //label="Rekomendasi"
            variant="outlined"
            fullWidth
            // value={input}
            onChange={(e) =>
              setInputFields({
                ...inputFields,
                rekomendasi: e.target.value,
              })
            }
          />
          <Box component="div" sx={fieldStyles}>
            <Button variant="contained" component="label">
              Upload Document
              <input
                hidden
                accept=".pdf,.jpg"
                // accept=".pdf,.doc,.docx,.xlsx,.xlsm,.xlsb,.xltx,.xltm,.xls,.xlt,.xml,.xlam,.xla,.xlw,.xlr,.ppt,.pptx,image/*"
                // multiple
                type="file"
                onChange={handleInputFile}
              />
            </Button>
            <span style={{ color: "red", marginLeft: "20px" }}>
              <small>
                * Format file upload yang diterima (.pdf, .jpg) (Maximum 10 Mb)
                {/* * Upload file (PDF, Word, Excel, PPT, Photo file) (Maximum 10
              Mb) */}
              </small>
            </span>

            {document !== null && (
              <>
                <br />
                <br />
                Files to upload:
              </>
            )}
            <br />

            {document !== null && (
              <div>
                <span style={{ opacity: "0.8" }}>{document.name}</span>

                <IconButton
                  aria-label="delete"
                  color="error"
                  onClick={() => handleRemoveFile()}
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            )}
          </Box>
        </Stack>
      </Box>
    </div>
  );
};

export default AnalisaPenyebab;
